import type { FaireProductEntity } from "../../entity_types/product";

export const p_2twu8afqzp: FaireProductEntity = {
  token: "p_2twu8afqzp",
  type: "product",
  name: "Gemstones Tree |Amethyst with Rose Quartz | Mix Crystal Tree",
  brandToken: "b_7ykttxenut",
  brandName: "Soothing Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/ef71c00e29ae731f99548c0556cbee7e65a76dba0b0dd590884aa4922d71db5d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1853717c64ca0e12c7c32634bcf4ed0a87b998ac2b5d95f5b02701101e6dca90.jpeg",
  ],
  priceDollars: 12.47,
  description:
    '💥Handmade Healing Gemstone Feng Shui Money Tree for Healing & Décor💥\n\nEnhance your space with handcrafted gemstone trees, are stunning home décor pieces and unique home accents, unique décor, and meaningful gifts, adding both beauty and meaning to your home.\n\n📌Feature:\n▪ Made from high-quality crystal.\n▪ Polished surface with smooth and shiny finish\n▪ Size: 300 Chips 10-12" (inch). \n\nSoothing Crystals has started a Journey in 2016, to offer high-quality, ethically-sourced crystals to collectors, artists, healers, and seekers from all walks of life.\n\nPeople Consider it as: Gemstone trees, home décor accent, unique home décor items, home decorate, symbolic trees, Tree of life, Feng Shui money tree, Bonsai gemstone tree, Gems tree, Money tree, Decorative gemstone tree.\n\nCrystal trees are ideal for spiritual and metaphysical stores, wellness and yoga studios, home décor shops, gift boutiques, Feng Shui practitioners, and online stores.',
  tags: [],
  msrpDollars: 44.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:05.725Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
